import React, { useState } from "react";
import "./AppListFilterComponent.scss";
import search from "../../assets/images/search-icon.svg";
import FilterSelect from "./filterSelect/FilterSelectComponent";
import AppService from "../../service/AppService";
import switchActive from "../../assets/images/switch-active.svg";
import switchInActive from "../../assets/images/switch-inactive.svg";
import { appList, statusList } from "../../service/survey";

const DEFAULT_FILTERS = { apps: null, status: null };

const apps = [{ text: "All", value: null }, ...appList.map((app) => ({ text: app.label, value: app.key }))];

const statuses = [{ text: "Any", value: null }, ...statusList.map((status) => ({ text: status.label, value: status.key }))];

function AppListFilter({ onFilterChanged, searchFieldChanged, onAppCreate, filters = DEFAULT_FILTERS }) {
    const [toggleNewBuilder, setToggleNewBuilder] = useState(AppService.newBuilderVersion);

    const toggleChangeNewBuilder = () => {
        setToggleNewBuilder((prev) => !prev);
        AppService.newBuilderVersion = !AppService.newBuilderVersion;
    };

    return (
        <div className="app-list-filter">
            <div className="search">
                <img src={search} alt="" />
                <input type="text" placeholder="search" onChange={searchFieldChanged} />
                <button onClick={onAppCreate}>New Application</button>
                <div>
                    {toggleNewBuilder ? "New Builder" : "Old Version"}
                    <img src={toggleNewBuilder ? switchActive : switchInActive} alt="active switch" onClick={toggleChangeNewBuilder} />
                </div>
            </div>
            <div className="filter">
                <FilterSelect label="Application" name="apps" onChanged={onFilterChanged} items={apps} selectedValue={filters.apps} />
                <FilterSelect label="Status" name="status" onChanged={onFilterChanged} items={statuses} selectedValue={filters.status} />
            </div>
        </div>
    );
}
export default AppListFilter;
